import { useDispatch } from "react-redux";
import { useCallback } from "react";
import styled from "styled-components";
import { Button } from "components";
import { Header } from "layout/ModalWindow/layout";
import { closeModal } from "layout";

interface ProctorConfirmStartModalProps {
	name: string;
	onConfirm: () => void;
	remainingAttempts: number;
	totalAttempts: number;
}

const ProctorConfirmStartModal = ({
	onConfirm,
	remainingAttempts,
	totalAttempts,
}: ProctorConfirmStartModalProps) => {
	const dispatch = useDispatch();

	const handleClose = useCallback(() => {
		dispatch(closeModal("ProctorConfirmStartModal"));
	}, [dispatch]);

	const handleConfirm = useCallback(() => {
		handleClose();
		onConfirm();
	}, [onConfirm, handleClose]);

	return (
		<Container>
			<Header onClose={handleClose} />
			<Content>
				<IconWrapper>
					<Icon>🎓</Icon>
				</IconWrapper>

				<Title>Начать экзамен с прокторингом?</Title>

				<Description>
					После подтверждения начнётся проверка оборудования
					и будет списана одна попытка.
				</Description>

				<InfoBlock>
					<InfoRow>
						<InfoLabel>Осталось попыток:</InfoLabel>
						<InfoValue>{remainingAttempts} из {totalAttempts}</InfoValue>
					</InfoRow>
				</InfoBlock>

				<ButtonsContainer>
					<ConfirmButton buttonTheme="primary" onClick={handleConfirm}>
						Начать
					</ConfirmButton>
					<Button buttonTheme="secondary" onClick={handleClose}>
						Отмена
					</Button>
				</ButtonsContainer>
			</Content>
		</Container>
	);
};

export default ProctorConfirmStartModal;

const Container = styled.div`
	background: #fff;
	border-radius: 16px;
	max-width: 480px;
	width: 100%;
	padding-top: 16px;
`;

const Content = styled.div`
	padding: 0 32px 32px;
	text-align: center;
`;

const IconWrapper = styled.div`
	margin-bottom: 16px;
`;

const Icon = styled.span`
	font-size: 48px;
`;

const Title = styled.h2`
	font-size: 1.5rem;
	font-weight: 600;
	margin: 0 0 12px;
	color: ${({ theme }) => theme.colors.primaryBlack};
`;

const Description = styled.p`
	color: ${({ theme }) => theme.colors.secondaryGrey};
	line-height: 1.6;
	margin-bottom: 24px;
`;

const InfoBlock = styled.div`
	background: ${({ theme }) => theme.colors.opacityLightGrey10};
	border-radius: 12px;
	padding: 16px 20px;
	margin-bottom: 24px;
`;

const InfoRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 8px 0;
`;

const InfoLabel = styled.span`
	color: ${({ theme }) => theme.colors.secondaryGrey};
	font-size: 0.95rem;
`;

const InfoValue = styled.span`
	font-weight: 600;
	font-size: 1.1rem;
	color: ${({ theme }) => theme.colors.primaryBlack};
`;

const ButtonsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

const ConfirmButton = styled(Button)`
	width: 100%;
	height: 48px;
	font-weight: 600;
`;
